export default __webpack_public_path__ + "static/media/kikisdelivery.05d899b1.gif";